import { ManagedUserStatus } from '../models/managed-user.model';

/** Legacy `_updateUserStatus`: only a deactivated user flips back to active. */
export const nextManagedUserStatus = (
  current: ManagedUserStatus,
): ManagedUserStatus => (current === 'Deactive' ? 'Active' : 'Inactive');
